/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Faction, FactionInterface } from "../Faction";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "assetsAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "assetIsNFT",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assetName",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assetOperators",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "assetTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "assets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "byName",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "extendedProperties",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "value",
            type: "string",
          },
        ],
        internalType: "struct EnumerableStringMap.MapEntry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
    ],
    name: "getExtendedProperty",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
    ],
    name: "getProperty",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "idRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "inventory",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "value",
            type: "bytes32",
          },
        ],
        internalType: "struct EnumerableMap.MapEntry[]",
        name: "properties",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "value",
            type: "string",
          },
        ],
        internalType: "struct EnumerableStringMap.MapEntry[]",
        name: "extendedProperties",
        type: "tuple[]",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "prestige",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "properties",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "key",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "value",
            type: "bytes32",
          },
        ],
        internalType: "struct EnumerableMap.MapEntry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Faction__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Faction> {
    return super.deploy(assetsAddress, overrides || {}) as Promise<Faction>;
  }
  getDeployTransaction(
    assetsAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(assetsAddress, overrides || {});
  }
  attach(address: string): Faction {
    return super.attach(address) as Faction;
  }
  connect(signer: Signer): Faction__factory {
    return super.connect(signer) as Faction__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FactionInterface {
    return new utils.Interface(_abi) as FactionInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Faction {
    return new Contract(address, _abi, signerOrProvider) as Faction;
  }
}
